import React from 'react';
import { Table } from 'semantic-ui-react';
import { format } from 'date-fns';

import InfoIcon from '@material-ui/icons/Info';

import { Field } from 'react-final-form';
import { RenderRadio } from 'forms';
import { SprayEventDisposal } from 'services/sprayEvents/types';
import classNames from 'classnames';
import { IncompleteDisposalSprayEvent } from '../../../../types';

interface Props {
    index: number;
    sprayEvent: IncompleteDisposalSprayEvent;
}

export default class CompleteCropSprayEventFormTableDisposalsRow extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { index, sprayEvent } = this.props;
        const {
            uuid,
            sprayedEntities,
            sprayEventVarieties,
            entityName,
            startDate
        } = sprayEvent;

        const rowClassname = classNames('complete-spray-event-form-table-row', {
            first: index === 0
        });

        return (
            <Table.Row className={rowClassname}>
                <Table.Cell>
                    <div className="table-cell-inner">
                        {index === 0 &&
                            format(new Date(startDate), 'MMM d yyyy')}
                    </div>
                </Table.Cell>
                <Table.Cell>
                    <div
                        className="table-cell-inner area"
                        title={`${sprayedEntities} (${sprayEventVarieties})`}
                    >
                        <span>{entityName}</span>
                        <InfoIcon className="complete-spray-event-form-info-icon" />
                    </div>
                </Table.Cell>
                <Table.Cell className="selectable-table-cell">
                    <div className="table-cell-inner center">
                        <Field
                            id={`${uuid}.targetCorp`}
                            name={uuid}
                            component={RenderRadio as any}
                            className="round-checkbox"
                            type="radio"
                            value={SprayEventDisposal.TARGET_CORP}
                            defaultValue={SprayEventDisposal.TARGET_CORP}
                        />
                    </div>
                </Table.Cell>
                <Table.Cell className="selectable-table-cell">
                    <div className="table-cell-inner center">
                        <Field
                            id={`${uuid}.shelterBelt`}
                            name={uuid}
                            component={RenderRadio as any}
                            className="round-checkbox"
                            type="radio"
                            value={SprayEventDisposal.SHELTER_BELT}
                        />
                    </div>
                </Table.Cell>
                <Table.Cell className="selectable-table-cell">
                    <div className="table-cell-inner center">
                        <Field
                            id={`${uuid}.headland`}
                            name={uuid}
                            component={RenderRadio as any}
                            className="round-checkbox"
                            type="radio"
                            value={SprayEventDisposal.HEADLAND}
                        />
                    </div>
                </Table.Cell>
                <Table.Cell className="selectable-table-cell">
                    <div className="table-cell-inner center">
                        <Field
                            id={`${uuid}.fallowLand`}
                            name={uuid}
                            component={RenderRadio as any}
                            className="round-checkbox"
                            type="radio"
                            value={SprayEventDisposal.FALLOW_LAND}
                        />
                    </div>
                </Table.Cell>
                <Table.Cell className="selectable-table-cell">
                    <div className="table-cell-inner center">
                        <Field
                            id={`${uuid}.other`}
                            name={uuid}
                            component={RenderRadio as any}
                            className="round-checkbox"
                            type="radio"
                            value={SprayEventDisposal.OTHER}
                        />
                    </div>
                </Table.Cell>
            </Table.Row>
        );
    }
}
